import { render, staticRenderFns } from "./HceProductSpecifications.vue?vue&type=template&id=697034b6&"
import script from "./HceProductSpecifications.vue?vue&type=script&lang=js&"
export * from "./HceProductSpecifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports